<template>
  <div class="collection-head">
    <div class="collection-head__top">
      <h1 class="collection-head__name h2">{{ product?.name ?? '' }}</h1>
      <div class="collection-head__buttons">
        <div
          class="collection-head__wish collection-head__wish-btn --black"
          @click="onBuySet"
        >
          <img
            alt="shopping"
            src="~/assets/img/svg/common/shopping.svg"
          />
        </div>
        <div class="collection-head__wish-btn">
          <WishBtn :product-id="+(product?.id ?? 0)" />
        </div>
      </div>

      <div class="collection-head__wish-btn">
        <WishBtn :product-id="+(product?.id ?? 0)" />
      </div>
    </div>
    <div
      v-if="tags.length > 0"
      class="collection-head__bottom"
    >
      <div
        v-for="(tag, index) in tags"
        :key="`collection-head__tag-${index}`"
        class="collection-head__tag"
        :class="{'--icon': Boolean(tag.iconLink)}"
        :style="`background: ${tag.bgColor}`"
      >
        <MobilePopUpTooltip>
          <template #item>
            <div class="tooltip__item">
              <div v-if="tag.label" v-html="tag.label"/>
              <template v-else-if="tag.iconLink">
                <img v-if="tag.iconLink" :src="tag.iconLink" width="20px" height="20px" alt=""/>
              </template>
            </div>
          </template>
          <template #tooltip>
            <div v-if="tag.tooltip" class="tooltip__hover">
              <span v-html="tag.tooltip"/>
            </div>
          </template>
        </MobilePopUpTooltip>
      </div>
    </div>
    <div
      v-if="$viewport.isGreaterOrEquals('lg')"
      class="collection-head__bottom-buttons"
    >
      <WishBtnWithText :product-id="+(product?.id ?? 0)" />
      <BuySetWithText @buySet="onBuySet" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import getPromotionsProduct from '~/utils/getPromotionsProduct';
import type {IProduct} from "#sitis/internal/controllers/products/models/Product";
import WishBtnWithText from '~/components/widget/WishBtnWithText.vue';
import BuySetWithText from "~/components/widget/BuySetWithText.vue";

const WishBtn = defineAsyncComponent(() => import('~/components/widget/WishBtn.vue'));
const MobilePopUpTooltip = defineAsyncComponent(() => import("~/components/common/MobilePopUpTooltip.vue"));

const props = defineProps({
  product: {
    type: Object as any,
    default: () => {}
  },
  products: {
    type: Array as any,
    default: [],
  }
});
const emits = defineEmits(['buySet']);

const tags = computed(() => {
  return getPromotionsProduct(props.product)
});

// const productsDots = computed(() => props.product?.productSetImageDots || []);
const productsDots = computed(() => {
  return (props?.product?.productSetImageDots || [])
    .filter((productDot: any) => props?.products?.find((t: IProduct) => String(t.id) === String(productDot.id || productDot?.product_id)));
});
// версия не обнаружена, видимо подмешивалась для а-б
const isVisibleButtonBuySet = computed(() => Boolean((productsDots.value || []).find((t: any) => t.version >= 2)));
const onBuySet = () => {
  const products = (productsDots.value || []).filter(Boolean);
  emits('buySet', products);
};
</script>

<style lang="scss" scoped>
.collection-head {
	width: 100%;

}

.collection-head__top {
	display: flex;
}

.collection-head__bottom {
	display: flex;
	flex-wrap: wrap;
	padding-top: 16px;
	margin-top: -10px;
	margin-left: -10px;

	& > * {
		margin-top: 10px;
		margin-left: 10px;
	}
}

.collection-head__name {
	margin-right: auto;
}

.collection-head__buttons {
	display: none;
  padding-top: 16px;
}

.collection-head__tag {
  display: flex;
  align-items: center;
	padding: 8px 24px;
  height: 38px;
	box-sizing: border-box;
	border-radius: 10px;
	background-color: #D3E6C6;
	color: #252525;
	font-size: 12px;
	font-weight: 600;

  &.--icon {
    justify-content: center;
    width: 38px;
    padding: 0;

    img {
      width: auto;
      max-width: 100%;
      height: auto;
      max-height: 100%;
    }
  }
  .tooltip__hover {
    top: 100%;
    right: 0;
    border-radius: 15px 0 15px 15px;
    transform: translateY(20px) translateX(10px);
    bottom: initial;
    max-width: 320px;
    z-index: 10;
    &:after {
      bottom: 100%;
      transform: translateY(10px);
    }
  }
}

.collection-head__wish-btn {
  display: none;
	&:deep(.wish-btn) {
		background-color: #F4F3F1;
	}
}

.collection-head__wish {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: 20px;
	width: 38px;
	height: 38px;
	cursor: pointer;
	background-color: #F4F3F1;
	border-radius: 10px;
	user-select: none;

	img {
		filter: invert(64%) sepia(4%) saturate(5675%) hue-rotate(314deg) brightness(106%) contrast(86%);
		transition: all 0.3s;
	}

	&:hover {
		img {
			transform: scale(1.1);
		}
	}
}
.collection-head__bottom-buttons {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  padding-top: 20px;
}

@media (max-width: 1023px) {
	.collection-head {
		margin-bottom: 24px;
	}
	.collection-head__name {
		font-size: 24px;
	}
	.collection-head__wish,
	.collection-head__wish-btn {
		display: none;
		width: 38px;
		height: 38px;

		&.--black img {
			filter: initial;
		}
	}
	.collection-head__buttons {
		display: flex;
		margin-top: -4px;
    padding-top: 0;

		& > * {
			display: flex;
			margin-left: 10px;

			&:first-child {
				margin-left: 0;
			}
		}
	}
	.collection-head__bottom {
		padding-top: 16px;
	}
	.collection-head__tag {
		padding: 6.5px 24px;
	}
}
@media (max-width: 859px) {
  .collection-head__tag {
    .tooltip__hover {
      max-width: 200px;
      left: 50%;
      transform: translateX(-50%) translateY(25px);
      border-radius: 15px;

      &:after {
        transform: translateX(-50%) translateY(5px) rotate(-90deg);
        left: 50%; right: initial;
        border-left: 10px solid #F4F3F1;
        border-right: initial;
      }
    }
  }
}
</style>
